module.exports = __webpack_public_path__ + "img/adas.16a496e2.png";